<template>
  <main style="width:100%; height: 100%;">
    <div class="main_container_registro_matricula">
      <div class="stepper_loading_container" v-if="loading">
        <v-card :class="`d-flex justify-center align-center stepper_loading`" style="margin: 0 auto" flat tile>
          <v-skeleton-loader type="avatar" class="mx-auto pa-0" outlined></v-skeleton-loader>
          <v-skeleton-loader type="list-item" class="mx-auto pa-0" tile outlined></v-skeleton-loader>

          <v-skeleton-loader type="avatar" class="mx-auto pa-0" outlined></v-skeleton-loader>
          <v-skeleton-loader type="list-item" class="mx-auto pa-0" tile outlined></v-skeleton-loader>

          <v-skeleton-loader type="avatar" class="mx-auto pa-0" outlined></v-skeleton-loader>

          <v-skeleton-loader type="list-item" class="mx-auto pa-0" tile outlined></v-skeleton-loader>
          <v-skeleton-loader type="avatar" class="mx-auto pa-0" outlined></v-skeleton-loader>
        </v-card>

        <v-skeleton-loader ref="skeleton" type="list-item" class="mx-auto pa-0 mt-10 mb-10 skeleton_70" :tile="false"
          :boilerplate="false" style="width:70%"></v-skeleton-loader>

        <v-skeleton-loader ref="skeleton" type="list-item-avatar-two-line" class="mx-auto pa-0" :tile="false"
          :boilerplate="false" style="width:100%"></v-skeleton-loader>

        <v-skeleton-loader ref="skeleton" type="list-item" class="pa-0 mt-8 mb-8 skeleton_90" :tile="false"
          :boilerplate="false" style="width:90%"></v-skeleton-loader>

        <v-skeleton-loader ref="skeleton" type="button" class="mx-auto pa-0 mt-8 mb-1" :tile="true" :boilerplate="false"
          style="width:100%" height="60"></v-skeleton-loader>

        <v-skeleton-loader ref="skeleton" type="button" class="mx-auto pa-0 mb-1" :tile="true" :boilerplate="false"
          style="width:100%" height="60"></v-skeleton-loader>

        <div :class="`d-flex justify-end`">
          <v-skeleton-loader ref="skeleton" type="list-item" class="pa-0 mt-8 mb-8" :tile="false" :boilerplate="false"
            style="width:30%"></v-skeleton-loader>

          <v-skeleton-loader ref="skeleton" type="list-item" class="pa-0 mt-8 mb-8 ml-2" :tile="false"
            :boilerplate="false" style="width:30%"></v-skeleton-loader>
        </div>

        <div :class="`d-flex justify-end`">
          <v-skeleton-loader ref="skeleton" type="button" class="pa-0 mb-1" :tile="false" :boilerplate="false"
            style="width:40%" height="40"></v-skeleton-loader>
        </div>
      </div>

      <div style="width:100%;margin:0 auto" v-show="!loading" id="steppertop">
        <v-stepper alt-labels v-model="e1">
          <v-stepper-header>
            <v-stepper-step step="1" :key="`1-step`" :complete="e1 > 1" :editable="e1 > 1 && !completed"
              v-if="this.isMinor">Menor de edad</v-stepper-step>
            <v-divider v-if="this.isMinor"></v-divider>
            <v-stepper-step step="2" :key="`2-step`" :complete="e1 > 2" :editable="e1 > 2 && !completed"
              v-if="this.isMinor">Horario</v-stepper-step>
            <v-divider v-if="this.isMinor"></v-divider>
            <v-stepper-step step="3" :key="`3-step`" :complete="e1 > 3" :editable="e1 > 3 && !completed"
              v-if="this.isMinor">Resumen</v-stepper-step>
            <v-divider v-if="this.isMinor"></v-divider>
            <v-stepper-step step="4" :key="`4-step`" :complete="e1 > 4" :editable="e1 > 4 && !completed"
              v-if="this.isMinor">Pago</v-stepper-step>
            <v-divider v-if="this.isMinor"></v-divider>
            <v-stepper-step step="5" :key="`5-step`" :complete="e1 > 5 && !completed"
              v-if="this.isMinor">Confirmación</v-stepper-step>

            <v-stepper-step step="1" :key="`1-step`" :complete="e1 > 1" :editable="e1 > 1 && !completed"
              v-if="!this.isMinor">Horario</v-stepper-step>
            <v-divider v-if="!this.isMinor"></v-divider>
            <v-stepper-step step="2" :key="`2-step`" :complete="e1 > 2" :editable="e1 > 2 && !completed"
              v-if="!this.isMinor">Resumen</v-stepper-step>
            <v-divider v-if="!this.isMinor"></v-divider>
            <v-stepper-step step="3" :key="`3-step`" :complete="e1 > 3" :editable="e1 > 3 && !completed"
              v-if="!this.isMinor">Pago</v-stepper-step>
            <v-divider v-if="!this.isMinor"></v-divider>
            <v-stepper-step step="4" :key="`4-step`" :complete="e1 > 4 && !completed"
              v-if="!this.isMinor">Confirmación</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content :key="`1-content`" step="1" style="width:100%" v-if="this.isMinor">
              <MinorConsentForm :isMinor="this.isMinor" :dataUsuarioMenor="this.dataUsuarioMenor" @goToStep="goToStep">
              </MinorConsentForm>
            </v-stepper-content>

            <v-stepper-content :key="`2-content`" step="2" style="width:100%" v-if="this.isMinor">
              <SelectSchedule @goToStep="goToStep" :step="e1" :isMinor="this.isMinor" @loading="loading = $event">
              </SelectSchedule>
            </v-stepper-content>

            <v-stepper-content :key="`3-content`" step="3" style="width:100% !important" v-if="this.isMinor">
              <Summary @goToStep="goToStep" :step="e1" :isMinor="this.isMinor"></Summary>
            </v-stepper-content>

            <v-stepper-content :key="`4-content`" step="4" style="width:100%" v-if="this.isMinor">
              <PaymentMethods @goToStep="goToStep" :step="e1" :isMinor="this.isMinor"></PaymentMethods>
            </v-stepper-content>

            <v-stepper-content :key="`5-content`" @goToStep="goToStep" step="5" style="width:100%" v-if="this.isMinor">
              <SuccessEnrollment :step="e1"></SuccessEnrollment>
            </v-stepper-content>

            <v-stepper-content :key="`1-content`" step="1" style="width:100%" v-if="!this.isMinor">
              <SelectSchedule @goToStep="goToStep" :step="e1" :isMinor="this.isMinor" @loading="loading = $event">
              </SelectSchedule>
            </v-stepper-content>

            <v-stepper-content :key="`2-content`" step="2" style="width:100% !important" v-if="!this.isMinor">
              <Summary @goToStep="goToStep" :step="e1" :isMinor="this.isMinor"></Summary>
            </v-stepper-content>

            <v-stepper-content :key="`3-content`" step="3" style="width:100%" v-if="!this.isMinor">
              <PaymentMethods @goToStep="goToStep" :step="e1"></PaymentMethods>
            </v-stepper-content>

            <v-stepper-content :key="`4-content`" @goToStep="goToStep" step="4" style="width:100%" v-if="!this.isMinor">
              <SuccessEnrollment :step="e1"></SuccessEnrollment>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </div>
  </main>
</template>

<script>
//import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SelectSchedule from "@/components/SelectSchedule.vue";
import Summary from "@/components/Summary.vue";
import PaymentMethods from "@/components/PaymentMethods.vue";
import SuccessEnrollment from "@/components/SuccessEnrollment.vue";
import MinorConsentForm from "@/components/MinorConsentForm.vue";

export default {
  name: "enrollment",
  created() {
    try {
      this.isMinor = this.$store.state.usuario.is_minor;
      //this.isMinor = false;
    } catch (er) {
      console.log("Error", er);
    }
  },
  components: {
    SelectSchedule,
    Summary,
    PaymentMethods,
    SuccessEnrollment,
    MinorConsentForm
  },
  data() {
    return {
      e1: 1,
      editable: true,
      completed: false,
      loading: true,
      isMinor: true,
      dataUsuarioMenor: null
    };
  },
  watch: {
    e1: function (val) {
      if ((val == 5 && this.isMinor) || val == 4) {
        this.completed = true;
      }
    }
  },
  methods: {
    goToStep(n) {
      this.e1 = n;
      this.$vuetify.goTo("#top", {
        duration: 0,
        offset: 0,
        easing: "linear"
      });
    },
    onClickChildIsMinor(value) {
      this.isMinor = value;
    }
  }
};
</script>
